import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import InputBase from '@material-ui/core/InputBase';
import Settings from '@material-ui/icons/Settings';

import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'hooks/useTranslation'

const useStyles = makeStyles(theme => {
	return {
		disabled_text_field: {
			color: '#000',
		},
	}
})

export default function BrandNameCard({
	mountType,
	inputModel = {
		brandName: '',
		productModel: '',
		productDescription: '',
		SDocGroupType: '',
	},
	onChangeInputModel,
	isShowSetSDocGroupType = false,
}) {
	const classes = useStyles()
	const { t } = useTranslation()

	return (
		<Card className={`border-t-4 border-card_top_border mb-5 p-5`}>
			<Grid className="flex flex-row justify-between items-center w-full">
				<Grid className="flex flex-row mt-4 mb-2">
					<Settings style={{ fontSize: 22 }} className="mr-1" />
					<Grid className="font-bold text-sm text-card_header_color">
						{t('brandCard.header')}
					</Grid>
				</Grid>
			</Grid>
			<Grid className="mt-3 mb-1 w-full">
				<Divider />
			</Grid>
			<Grid className="flex flex-row mt-4 mb-2 gap-x-2">
				<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
					<Grid className="flex flex-row">
						<Grid>{t('brandCard.brandName')}</Grid>
						<Grid className="text-red-500">*</Grid>
					</Grid>
					<Grid
						className={` text-xs flex justify-start items-center rounded h-10  w-full border border-gray-300`}>
						<InputBase
							className={`w-full h-full px-2 ${(mountType && mountType !== "ModifyInfo") ? classes.disabled_text_field : ''
								}`}
							name="brandName"
							value={inputModel.brandName}
							onChange={onChangeInputModel}
							disabled={(mountType && mountType !== "ModifyInfo")}
						/>
					</Grid>
				</Grid>
				<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
					<Grid className="flex flex-row">
						<Grid>{t('brandCard.model')}</Grid>
						<Grid className="text-red-500">*</Grid>
					</Grid>
					<Grid
						className={` text-xs flex justify-start items-center rounded h-10  w-full border border-gray-300`}>
						<InputBase
							className={`w-full h-full px-2  ${(mountType && mountType !== "ModifyInfo") ? classes.disabled_text_field : ''
								}`}
							name="productModel"
							value={inputModel.productModel}
							onChange={onChangeInputModel}
							disabled={(mountType && mountType !== "ModifyInfo")}
						/>
					</Grid>
				</Grid>
				{ }
				<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
					<Grid className="flex flex-row">
						<Grid>
							{t('brandCard.description')}
						</Grid>
						<Grid className="text-red-500">*</Grid>
					</Grid>
					<Grid
						className={` text-xs flex justify-start items-center rounded h-10  w-full border border-gray-300`}>
						<InputBase
							className={`w-full h-full px-2  ${(mountType && mountType !== "ModifyInfo") ? classes.disabled_text_field : ''
								}`}
							name="productDescription"
							value={inputModel.productDescription}
							onChange={onChangeInputModel}
							placeholder="เช่น Access Point / Wireless Earphone / Notebook Computer"
							disabled={(mountType && mountType !== "ModifyInfo")}
						/>
					</Grid>
				</Grid>

			</Grid>
			{isShowSetSDocGroupType && (
				<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
					<Grid className="flex flex-row">
						<Grid>
							{t('brandCard.groupType')}
						</Grid>
					</Grid>
					<Grid
						className={` text-xs flex justify-start items-center rounded h-10  w-full border border-gray-300`}>
						<InputBase
							className={`w-full h-full px-2  ${(mountType && mountType !== "ModifyInfo") ? classes.disabled_text_field : ''
								}`}
							name="SDocGroupType"
							value={inputModel.SDocGroupType}
							placeholder=""
							disabled={true}
						/>
					</Grid>
				</Grid>
			)}
		</Card>
	)
}
